export const TRACKING_EVENTS = {
  QUERY_RUN: "ai-quick-answers-query-run",
  DOWNLOAD: "ai-quick-answers-download",
}
